import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestQuerySchema = z.object({
  researchRequestQueryId: PrimaryKeySchema,
  researchRequestId: PrimaryKeySchema,
  query: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequestQuery = z.infer<typeof ResearchRequestQuerySchema>;

export const ResearchRequestQueriesSchema = z.array(ResearchRequestQuerySchema);

export type ResearchRequestQueries = z.infer<
  typeof ResearchRequestQueriesSchema
>;

export const ResearchRequestQueriesQuerySchema = z.object({
  researchRequestIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  researchRequestQueryIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
});

export type ResearchRequestQueriesQuery = z.infer<
  typeof ResearchRequestQueriesQuerySchema
>;

export const CreateResearchRequestQuerySchema = ResearchRequestQuerySchema.pick(
  {
    researchRequestId: true,
    query: true,
  },
);

export type CreateResearchRequestQuery = z.infer<
  typeof CreateResearchRequestQuerySchema
>;
